import React, { ReactNode } from 'react'
import { Col } from 'react-styled-flexboxgrid'
import styled from 'styled-components'
import media from 'css-in-js-media'
import Title from './Title'
import { BodyCopy, H2, H3 } from './Typography'
import { Variables } from '../styles/Variables'
import { StyledButton } from './Button'

const StyledText = styled(Title)`
    margin: 0;
    ${BodyCopy} {
        margin: 0;
    }
    ${StyledButton} {
        margin-top: 30px;
        border-color: ${Variables.color.cocoa};
        color: ${Variables.color.cocoa};
        &:before {
            border-color: ${Variables.color.cocoa};
        }
        &:hover {
            color: ${Variables.color.white};
            border-color: ${Variables.color.gold};
            &:before {
                border-color: ${Variables.color.white};
            }
        }
    }
    ${BodyCopy} {
        text-transform: uppercase;
        font-size: 16px;
        ${media('<desktop')} {
            font-size: 14px;
        }
    }
    ${H3} {
        margin-top: 20px;
        margin-bottom: 5px;
    }
    ${H2} {
        max-width: 100%;
        margin-top: 30px;
        margin-bottom: 5px;

        ${media('<desktop')} {
            margin-top: 30px;
        }
    }

    ${media('<desktop')} {
        margin: 30px 0px;
    }
`

export const StyledFrame = styled(Col)<{
    $bgColor: string
    $alignItems: string
}>`
    position: relative;
    display: flex;

    height: 100vh;
    min-height: 900px;
    padding: 37px 40px;
    background-color: ${(props) =>
        props.$bgColor ? props.$bgColor : Variables.color.lightGrey};
    align-items: ${(props) =>
        props.$alignItems ? props.$alignItems : 'center'};

    ${media('<desktop')} {
        height: 100%;
        min-height: 100%;
        padding: 30px;
    }
`

interface Props {
    mobileWidth: number
    width: number
    textAlign: string
    bgColor: string
    data: ReactNode
    alignItems: string
}

const BlockText = ({
    width,
    mobileWidth,
    textAlign,
    bgColor,
    alignItems,
    data,
    ...rest
}: Props) => {
    return (
        <StyledFrame
            xs={mobileWidth}
            md={width}
            $bgColor={bgColor}
            $alignItems={alignItems}
            {...rest}
        >
            <StyledText align={textAlign}>{data}</StyledText>
        </StyledFrame>
    )
}

export default BlockText
